import lozad from 'lozad';
import Splide from '@splidejs/splide';
import CONFIG from '@js/config/splideConfig';
import { CustomPagination } from '@js/components/splide/extensions/CustomPagination';

const observer = lozad(
    '.js-splide:not([data-manual-init="true"]):not([data-instant-init="true"])',
    {
        load: (sliderElement) => {
            const config = CONFIG[sliderElement.dataset.config] || CONFIG.default;

            sliderElement.splide = new Splide(sliderElement, config);

            sliderElement.splide.mount({ CustomPagination });

            window.dispatchEvent(
                new CustomEvent('sliderInitialized', {
                    detail: { sliderElement },
                })
            );
        },
    }
);

['DOMContentLoaded', 'RemoteContentLoaded', 'livewire.component.rendered'].forEach((event) =>
    window.addEventListener(event, () => observer.observe())
);
